<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" :back-level="1000" />
    <div class="topBackRect" />
    <div class="topImg">
      <van-swipe v-if="data">
        <van-swipe-item>
          <img v-lazy="data.type.cardImgFront?data.type.cardImgFront:'/img/defaultcertificate.jpg'">
        </van-swipe-item>
        <van-swipe-item>
          <img v-lazy="data.type.cardImgBack?data.type.cardImgBack:'/img/defaultcertificate.jpg'">
        </van-swipe-item>
      </van-swipe>
    </div>
    <div v-if="data" class="dataRect">
      <div class="rectTitle" :style="'color:'+GetColorMainBack()"><b>{{ data.type.name }}</b></div>
      <van-row gutter="20" class="valueRect">
        <van-col span="6" :style="'color:'+GetColorMainBack()">简介</van-col>
        <van-col span="18">
          {{ data.type.resume }}
        </van-col>
      </van-row>
      <van-row gutter="20" class="valueRect">
        <van-col span="6" :style="'color:'+GetColorMainBack()">售价</van-col>
        <van-col span="18">
          CNY
          <del v-if="data.type.sellPriceFee!==data.type.basePriceFee">
            {{ ShowMoney(data.type.basePriceFee*0.01) }}
          </del>
          &nbsp;<b>{{ ShowMoney(data.type.sellPriceFee*0.01) }}</b>
        </van-col>
      </van-row>
      <!-- <van-row gutter="20" class="valueRect">
        <van-col span="6" :style="'color:'+GetColorMainBack()">剩余数量</van-col>
        <van-col span="18">
          {{ data.sell.nowNum }}
        </van-col>
      </van-row> -->
    </div>
    <div v-if="data" class="dataRect">
      <div class="rectTitle" :style="'color:'+GetColorMainBack()">包含内容</div>
      <van-row v-for="item in data.itemList" :key="item.cardItemId" gutter="20" class="valueRect">
        <template "item.type==='CASH' && item.defaultValue!==0">
          <van-col span="6" :style="'color:'+GetColorMainBack()">金额</van-col>
          <van-col span="18">
            CNY {{ ShowMoney(item.defaultValue*0.01) }}
          </van-col>
        </template>
        <template v-if="item.type==='CASH_GIFT' && item.defaultValue!==0">
          <van-col span="6" :style="'color:'+GetColorMainBack()">赠送金额</van-col>
          <van-col span="18">
            CNY {{ ShowMoney(item.defaultValue*0.01) }}
          </van-col>
        </template>
        <template v-if="item.type==='SCORE' && item.defaultValue!==0">
          <van-col span="6" :style="'color:'+GetColorMainBack()">积分</van-col>
          <van-col span="18">
            {{ item.defaultValue }}
          </van-col>
        </template>
        <template v-if="item.type==='LIMIT_DATE' && item.defaultValue!==0">
          <van-col span="6" :style="'color:'+GetColorMainBack()">有效期</van-col>
          <van-col span="18">
            {{ item.defaultValue }}天
          </van-col>
        </template>
        <template v-if="item.type==='COUNT'">
          <van-col span="6" :style="'color:'+GetColorMainBack()">{{ item.title }}</van-col>
          <van-col span="18">
            <b>{{ item.defaultValue }}</b>{{ item.unitName }}
          </van-col>
        </template>
        <template v-if="item.type==='TEXT'">
          <van-col span="6" :style="'color:'+GetColorMainBack()">{{ item.title }}</van-col>
          <van-col span="18">
            {{ item.about }}
          </van-col>
        </template>
      </van-row>
    </div>
    <div v-if="data && data.type.about" class="dataRect">
      <div class="rectTitle" :style="'color:'+GetColorMainBack()">详情</div>
      <div class="aboutStr" v-html="data.type.about" />
    </div>
    <div v-if="data" class="dataRect">
      <div class="rectTitle" :style="'color:'+GetColorMainBack()">购买<b>{{ data.type.name }}</b></div>
      <van-field
        v-model="dataForm.hashCode"
        required
        clearable
        label="邀请码"
        placeholder="请输入购买邀请码"
      />
      <van-field
        v-model="dataForm.viperName"
        required
        clearable
        label="姓名"
        placeholder="请输入姓名"
      />
      <van-field
        v-model="dataForm.viperPhoneNumber"
        required
        clearable
        label="手机号码"
        placeholder="请输入手机号码"
      />
      <van-field
        v-model="dataForm.idCardNumber"
        required
        clearable
        label="身份证号码"
        placeholder="请输入身份证号码"
      />
      <van-field
        v-model="dataForm.passportNumber"
        clearable
        label="护照号码"
        placeholder="请输入护照号码(国外行程必填)"
      />
      <template v-for="(item,index) in regJson.select">
        <div :key="index" class="van-cell van-cell--required van-field">
          <div class="van-cell__title van-field__label"><span>{{ item.title }}</span></div>
          <van-checkbox-group v-model="radioSelect[index]" direction="horizontal">
            <van-checkbox v-for="(text,textIndex) in item.list" :key="index+'_'+textIndex" :checked-color="GetColorMainBack()" :name="text">{{ text }}</van-checkbox>
          </van-checkbox-group>
        </div>
      </template>
    </div>
    <div class="emptyRect" />
    <div class="buttonRect">
      <van-button v-if="data && data.sell.nowNum>0" square type="danger" size="large" :color="GetColorMain()" :loading="buttonLoading" loading-text="生成订单中..." @click="onBuy">立即购买</van-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Dialog, Button, Swipe, SwipeItem, Lazyload, Tag, Field, Checkbox, CheckboxGroup } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Dialog.name]: Dialog,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Button.name]: Button,
    [Lazyload.name]: Lazyload,
    [Tag.name]: Tag,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '购买会员卡',
      backurl: '/memberCard/memberCardList',
      buttonLoading: false,
      id: undefined,
      typeId: undefined,
      data: undefined,
      dataForm: {
        sellCodeId: undefined,
        hashCode: undefined,
        viperName: '',
        viperPhoneNumber: '',
        idCardNumber: '',
        passportNumber: ''
        // viperName: '陈石千',
        // viperPhoneNumber: '18198218602',
        // idCardNumber: '52011319880501043X',
        // passportNumber: 'E123456'
      },
      regJson: undefined,
      radioSelect: [[], [], [], [], [], [], [], [], [], [], [], [], [], []]
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.id = this.$route.params.code
    this.typeId = getUrlKey('typeid')
    this.dataForm.sellCodeId = this.id
    this.init()
  },
  methods: {
    getUrlKey,
    MyNotify,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      this.data = undefined
      this.loadingPage = true
      var url = ''
      var id = ''
      if (this.id && this.id !== '0') {
        url = '/MemberCard/getMemberCardBuyInfo'
        id = this.id
      } else {
        url = '/MemberCard/getMemberCardBuyInfoByType'
        id = this.typeId
      }
      request({
        url: url,
        method: 'post',
        params: { id: id }
      }).then(response => {
        this.loadingPage = false
        if (!response.success) {
          return
        }
        this.data = response.data
        this.title = '购买' + this.data.type.name
        this.regJson = undefined
        if (this.data.type.regSelectJson) {
          this.regJson = JSON.parse(this.data.type.regSelectJson)
        }
        if (this.data.unFinishCardHashCode) {
          Dialog.confirm({
            title: '是否查看尚未完成的订单',
            message: '您有一张 ' + this.data.unFinishCardVipName + ' 的尚未完成支付的会员卡订单，是否前往查看?',
            confirmButtonText: '立即查看',
            cancelButtonText: '暂不查看'
          }).then(() => {
            this.$router.push('/m/' + this.data.unFinishCardHashCode)
          }).catch(() => {
          })
        }
      })
    },
    checkInput() {
      if (!this.dataForm.viperName || this.dataForm.viperName.length < 2) {
        MyNotify('error', '请输入姓名')
        return false
      }
      if (!this.dataForm.viperPhoneNumber || this.dataForm.viperPhoneNumber.length < 10) {
        MyNotify('error', '请输入手机号码')
        return false
      }
      if (!this.dataForm.idCardNumber && !this.dataForm.passportNumber) {
        MyNotify('error', '身份证号码或护照号码至少填写一个')
        return false
      }
      if (this.dataForm.passportNumber && this.dataForm.passportNumber.length < 6) {
        MyNotify('error', '请输入完整的护照号码')
        return false
      }
      if (this.dataForm.idCardNumber && this.dataForm.idCardNumber.length !== 18) {
        MyNotify('error', '请输入18位身份证号码')
        return false
      }
      return true
    },
    onBuy() {
      if (!this.checkInput()) {
        return
      }
      this.dataForm.privateRemark = ''
      this.dataForm.typeId = this.typeId
      this.radioSelect.forEach(el => {
        if (el) {
          el.forEach(el2 => {
            this.dataForm.privateRemark += el2 + ','
          })
        }
      })
      this.buttonLoading = true
      request({
        url: '/MemberCard/buyMemberCard',
        method: 'post',
        data: this.dataForm
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        this.$router.push('/m/' + response.data)
      })
    }
  }
}
</script>
<style scoped>
.topBackRect{
  position: absolute;
  background-color: #000;
  width: 100%;
  height: 20vh;
}
.topImg{
  padding: 1em;
  border-radius: 1em;
  overflow: hidden;
}
.topImg img{
  width:100%;
  min-height: 40vw;
  border-radius: 1em;
  overflow: hidden;
}
.dataRect{
  background-color: #fff;
  margin-bottom: 1em;
  padding: 1em;
}
.dataRect .valueRect{
  font-size: 0.8em;
  padding: 0.4em 0;
}
.dataRect .rectTitle{
  font-size: 0.9em;
  font-weight: 700;
  padding-bottom: 0.5em;
}
.aboutStr{
  font-size: 0.8em;
}
.aboutStr img{
  max-width: 100%;
}

.buttonRect{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3em;
  background-color: #fff;
}
.emptyRect{
  height: 3em;
}
</style>
